<div class="filter-sort-form" *ngIf="model && model.filterBy">
  <div class="d-flex flex-wrap justify-content-between">
    <form>
      <rr-dropdown-field
        name="dropdown2"
        [(ngModel)]="model.filterBy.value"
        [settings]="dropDownSettings"
        [options]="options"
        [optionsTemplate]="optionsTemplate"
        sort="none"
        (valueChanged)="changeSelectedFilter($event)"
        (clearInput)="onClearInput($event)"
        readonly
      ></rr-dropdown-field>
    </form>
  </div>
</div>
